<template>
    <ValidationObserver ref="form">
        <div class="row">
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="">
                            <h6>{{ dateForTimeSheets(period.start_date) }} to
                                {{ dateForTimeSheets(period.end_date) }}</h6>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Select the Applicant</label>
                                    <select
                                        class="custom-select"
                                        v-model="info.applicant_id"
                                    >
                                        <option v-for="applicant in applicants"
                                                :value="applicant.id">
                                            {{ applicant.name ?? '' }} {{ applicant.last_name ?? '' }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="table-holder table-responsive ">
                            <div class="table-like">
                                <div class="top-row">
                                    <div class="date-column">Date</div>
                                    <div class="location-column">
                                        <nobr>Location/Property Name</nobr>
                                    </div>
                                    <div class="in-out-column">Time In</div>
                                    <div class="in-out-column">Time Out</div>
                                    <div class="hours-column">
                                        <nobr>Total Hours</nobr>
                                    </div>
                                </div>
                                <div
                                    v-for="(day, index) in info.schedule.slice(0, 7)"
                                    :key="index"
                                >
                                    <DayItem
                                        :day="day"
                                        @data-changed="updateForm"
                                    ></DayItem>
                                </div>
                                <div class="total-row">
                                    <div class="text-right">
                                        <b>Week 1 Total: Regular Hours {{ formatTime (firstWeekTotal)}} Overtime Hours {{formatTime(firstWeekOvertime)}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-holder table-responsive ">
                            <div class="table-like">
                                <div class="top-row">
                                    <div class="date-column">Date</div>
                                    <div class="location-column">
                                        <nobr>Location/Property Name</nobr>
                                    </div>
                                    <div class="in-out-column">Time In</div>
                                    <div class="in-out-column">Time Out</div>
                                    <div class="hours-column">
                                        <nobr>Total Hours</nobr>
                                    </div>
                                </div>
                                <div
                                    v-for="(day, index) in info.schedule.slice(7, 14)"
                                    :key="index"
                                >
                                    <DayItem
                                        :day="day"
                                        @data-changed="updateForm"
                                    ></DayItem>
                                </div>
                                <div class="total-row">
                                    <div class="text-right">
                                        <b>Week 2 Total: Regular Hours {{ formatTime (secondWeekTotal)}} Overtime Hours {{formatTime(secondWeekOvertime)}}</b>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex mb-4">
                            <div class="mr-3">
                                <b>Total hours</b>
                                <span>{{ formatTime(firstWeekTotal + secondWeekTotal) }}</span>
                            </div>
                            <div class="mr-3">
                                Regular worked hours: <span>{{ formatTime(totalRegularHours) }}</span>
                            </div>
                            <div class="mr-3">
                                Overtime:
                                <span>{{ formatTime(totalOvertime) }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group form-group-1">
                                <textarea
                                    v-model="info.comment"
                                    type="text"
                                    class="form-control height-2"
                                    placeholder="Comments/Reminders/Change of address or phone numder:"
                                ></textarea>
                                </div>
                            </div>
                            <div class="col-12 mb-4">
                                <h6 v-show="info.trainings.length > 1">Training</h6>
                                <div v-for="(training, index) in info.trainings"
                                     :key="index">

                                    <TrainingItem
                                        :training="training"
                                        @data-changed="updateTrainingForm"
                                    />
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="text-right mb-4">
                                    <button
                                        class="btn btn--outline-primary btn--small"
                                        @click="addTraining"
                                    >
                                        +Add Training
                                    </button>
                                </div>
                            </div>
                            <div class="col-12 text-right ">
                                <div class="btns-wrap">
                                    <a
                                        :href="`/master-admin/timesheets/periods/${period.id}/timesheets?period=${period.id}`"
                                        class="btn btn--outline-primary w-100 w-sm-auto">
                                        Cancel
                                    </a>
                                    <button
                                        class="btn btn--secondary w-100 w-sm-auto"
                                        @click="prepareInfo()"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DayItem from "./DayItem.vue";
import PersonalDetailsForm from "../../../AppUser/resources/js/CommonForms/PersonalDetailsForm.vue";
import TrainingItem from "./TrainingItem.vue";
import TimeSheetService from "./services/TimeSheetService";
import TimesheetCalculation from "../../../../../resources/js/mixins/TimesheetCalculation";


export default {
    name: 'CustomTimesheet',
    mixins: [DateConverter, TimesheetCalculation],
    components: {TrainingItem, PersonalDetailsForm, DayItem, DatePicker,},
    props: {
        period: {
            type: Object,
            required: true,
        },
        applicants: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            info: {
                trainings: [],
                schedule: [],
                comment: null,
                isSubmitted: false,
                applicant_id: null,
                period_id: this.period.id,
                regular: null,
                overtime: null,
            },
            totalRegularHours: null,
            totalOvertime: null,

            firstWeekRegular: null,
            firstWeekTotal: null,
            firstWeekOvertime:null,

            secondWeekRegular:null,
            secondWeekOvertime: null,
            secondWeekTotal: null,
            arrayOfDays: [],
        }
    },
    methods: {
        addTraining() {
            this.info.trainings.push({
                id: null,
                index: this.info.trainings.length,
                location: null,
                trainer: null,
                training_start_day: null,
                training_end_day: null,
                training_start_time: null,
                training_end_time: null,
            })
        },

        createWeeks() {
            const endDate = moment(this.period.start_date).add(13, 'days');
            for (let start = moment(this.period.start_date); start.isSameOrBefore(endDate); start.add(1, 'days')) {
                const formattedDate = start.format('dddd|MMMM D, YYYY');
                this.arrayOfDays.push(formattedDate);
            }
        },
        generateSchedule() {
            this.info.schedule = [];
            this.arrayOfDays.forEach(day => {
                this.info.schedule.push({
                    index: day,
                    date: day,
                    location: null,
                    time_in: null,
                    time_out: null,
                    result: null,
                });
            });
        },
        async prepareInfo() {
            this.$showLoadingMessage()
            if (this.info.applicant_id) {
                this.info.isSubmitted = true
                this.info.overtime = this.totalOvertime
                this.info.regular = this.totalRegularHours
                try {
                    await TimeSheetService.saveCustomTimesheet(this.period.id, this.info)
                    this.$showSuccessMessage('Timesheet was submitted!')
                    setTimeout(() => {
                        window.location.href = `/master-admin/timesheets/periods/${this.period.id}/timesheets?period=${this.period.id}`
                    }, 100)
                } catch (e) {
                    console.error(e)
                    this.$showErrorMessage('This timesheet was not saved')
                }
            } else {
                this.$showErrorMessage('Please select an employee')
            }
        },
        updateForm(result) {
            const index = this.info.schedule.findIndex(day => day.index === result.index);
            if (index !== -1) {
                this.info.schedule.splice(index, 1, result);
            }
            this.calculateTotal('first')
            this.calculateTotal('second')
            this.formatTime(this.firstWeekTotal)
            this.formatTime(this.secondWeekTotal)
            this.formatTime(this.firstWeekTotal + this.secondWeekTotal)
            this.calculateRegularAndOvertime();
        },
        updateTrainingForm(result) {
            const index = this.info.trainings.findIndex(training => training.index === result.index);
            if (index !== -1) {
                this.info.trainings.splice(index, 1, result);
            }
        }
    },


    mounted() {
        this.createWeeks()
        this.generateSchedule()
    },

}

</script>

<style scoped>
</style>
